var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
const useQueryCache = true;
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: useQueryCache
                ? 1000 * 60 * 60 * 24 /* 24 hours */
                : 1000 * 60 * 5 /* 5 minutes */,
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 5000,
            throwOnError: true,
        },
    },
});
export function setupQueryCache() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!useQueryCache)
            return;
        const localStoragePersistor = createAsyncStoragePersister({
            storage: window.localStorage,
        });
        yield persistQueryClient({
            buster: '3',
            persister: localStoragePersistor,
            queryClient,
        });
    });
}
export default queryClient;
